(() => {
  const initFeaturedProducts = (root = document) => {
    root.querySelectorAll('[data-featured-products-slider]').forEach((slider) => {
      if (slider.dataset.featuredProductsReady === 'true') return;

      const section = slider.closest('.sixave-featured-products');
      const sliderWrap = slider.closest('.sixave-featured-products__slider-wrap');
      const nextButton = section ? section.querySelector('.sixave-featured-products__nav--next') : null;
      const prevButton = section ? section.querySelector('.sixave-featured-products__nav--prev') : null;
      const updateEdgeFades = (swiper) => {
        if (!sliderWrap) return;

        sliderWrap.classList.toggle('is-scrollable-prev', !swiper.isBeginning);
        sliderWrap.classList.toggle('is-scrollable-next', !swiper.isEnd);
      };

      if (typeof Swiper !== 'undefined') {
        const featuredProductsSwiper = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 12,
          watchOverflow: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            575: {
              slidesPerView: 2,
              spaceBetween: 14,
            },
            750: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 16,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 16,
            },
            1400: {
              slidesPerView: 6,
              spaceBetween: 16,
            },
          },
          on: {
            afterInit(swiper) {
              updateEdgeFades(swiper);
            },
            slideChange(swiper) {
              updateEdgeFades(swiper);
            },
            reachBeginning(swiper) {
              updateEdgeFades(swiper);
            },
            reachEnd(swiper) {
              updateEdgeFades(swiper);
            },
            resize(swiper) {
              updateEdgeFades(swiper);
            },
          },
        });

        updateEdgeFades(featuredProductsSwiper);
      } else {
        const wrapper = slider.querySelector('.swiper-wrapper');

        if (wrapper && nextButton && prevButton) {
          const scrollSlider = (direction) => {
            const distance = slider.clientWidth * 0.85 * direction;
            wrapper.scrollBy({ left: distance, behavior: 'smooth' });
          };

          nextButton.addEventListener('click', () => scrollSlider(1));
          prevButton.addEventListener('click', () => scrollSlider(-1));
        }
      }

      slider.dataset.featuredProductsReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => initFeaturedProducts());
  document.addEventListener('shopify:section:load', (event) => initFeaturedProducts(event.target));
})();
